import React from "react";
import { StatusLabels } from "../../../shared/infrastructure/StatusLabels";
import { useStateApp } from "../../../state/useStateApp";
import { Translate as T } from "react-localize-redux";
import {
  Box,
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { ILocationState } from "../../../containers/Payment/Payment";
import { useLocation } from "react-router-dom";
import logoKushki from "../../../assets/logos/kushki_logo.svg";
import { get } from "lodash";
import { ResumeProps } from "../../../containers/Resume/Resume";

const useStyles = makeStyles((theme) => ({
  boxStyle: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  checkSubText: {
    fontSize: "16px",
  },
  checkText: {
    fontSize: "32px",
  },
  contentCard: {
    marginBottom: "9px",
    marginTop: "5px",
    paddingTop: "10px",
  },
  detailCard: {
    borderRadius: "10px",
    boxShadow:
      "0px 15px 35px rgba(60, 66, 87, 0.12), 0px 5px 15px rgba(0, 0, 0, 0.12)",
    margin: "auto",
    marginLeft: "19.5px",
    marginRight: "19.5px",
    padding: "0px 16px 40px 16px",
  },
  kpay: {
    margin: "0px auto",
    marginTop: "25px",
  },
  logo: {
    display: "flex",
    justifyContent: "center",
    margin: "0px auto",
    paddingTop: "100px",
  },
  mobileBoxStyle: {
    display: "flex",
    flexWrap: "wrap-reverse",
    justifyContent: "space-between",
  },
  productImage: {
    borderRadius: "10px",
    height: "80px",
    maxHeight: "80px",
    maxWidth: "80px",
    objectFit: "cover",
    width: "100%",
  },
  productNameText: {
    textTransform: "uppercase",
  },
  scrollDownSm: {
    [theme.breakpoints.down("sm")]: {
      overflow: "auto",
    },
  },
  successSubTitleStyle: {
    color: "initial",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
    paddingTop: "12px",
    textAlign: "center",
  },
  summarizeDescription: {
    color: "#5c5c5c",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "initial",
    lineHeight: "136%",
    margin: "8px 0px",
    textAlign: "left",
  },
  summarizeInfo: {
    color: "#293036",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "120%",
    margin: "8px 0px",
    textAlign: "left",
    width: "50%",
  },
  summarizePersonalInfo: {
    color: "#293036",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "120%",
    margin: "4px 0px",
    textAlign: "left",
    width: "100%",
  },
  summarizeTitleStyle: {
    alignContent: "center",
    lineHeight: "120%",
    marginBottom: "26px",
    marginTop: "26px",
    textAlign: "center",
  },
  titleStyle: {
    color: "initial",
    textAlign: "center",
  },
}));

const ResumeBankBogota: (props: ResumeProps) => JSX.Element = (
  props: ResumeProps
) => {
  const classes = useStyles();
  const location = useLocation<ILocationState>();
  const { resumeData, smartlink: smartlinkData } = location.state;
  const status: string = StatusLabels[get(resumeData, "status", "")];
  const { isMobile } = useStateApp();

  return (
    <Grid container justify="center">
      <Grid item xs={12} md={7} lg={7}>
        <Card className={classes.detailCard}>
          <CardContent className={classes.contentCard}>
            <Grid container xs={12} md={12} lg={12}>
              <Grid item className={classes.logo}>
                <img
                  src={logoKushki}
                  className={classes.productImage}
                  alt={smartlinkData?.generalConfig.productName}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Box mt={2}>
                  <Typography className={classes.titleStyle} variant={"h2"}>
                    <T id="summarizeBankBogota.successTitle" />
                  </Typography>
                  <Typography className={classes.successSubTitleStyle}>
                    <T id="summarizeLabelsForSubscription.successSubTitle" />
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Box>
                  <Typography
                    variant={"h5"}
                    className={classes.summarizeTitleStyle}
                  >
                    <T id="summarizeBankBogota.summarizeTitle" />
                  </Typography>
                </Box>
                <Box m={isMobile ? -2 : ""}>
                  <Box className={classes.boxStyle}>
                    <Grid container xs={12} md={5} lg={5}>
                      <Grid item xs={4} md={12} lg={12}>
                        <Typography className={classes.summarizeDescription}>
                          <T id="summarizeBankBogota.summarizeProductLabel" />
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={12}
                        lg={12}
                        className={classes.scrollDownSm}
                      >
                        <Typography className={classes.summarizeInfo}>
                          {smartlinkData.generalConfig.productName}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container xs={12} md={5} lg={5}>
                      <Grid item xs={4} md={12} lg={12}>
                        <Typography className={classes.summarizeDescription}>
                          <T id="summarizeLabelsForSubscription.subscriptionIDLabel" />
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={12}
                        lg={12}
                        className={classes.scrollDownSm}
                      >
                        <Typography className={classes.summarizeInfo}>
                          {resumeData.subscriptionId}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className={classes.boxStyle}>
                    <Grid container xs={12} md={5} lg={5}>
                      <Grid item xs={4} md={12} lg={12}>
                        <Typography className={classes.summarizeDescription}>
                          <T id="summarizeBankBogota.summarizeAmountLabel" />
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={12}
                        lg={12}
                        className={classes.scrollDownSm}
                      >
                        <Typography className={classes.summarizeInfo}>
                          {resumeData.totalAmount + " " + resumeData.currency}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container xs={12} md={5} lg={5}>
                      <Grid item xs={4} md={12} lg={12}>
                        <Typography className={classes.summarizeDescription}>
                          <T id="summarizeBankBogota.summarizeStateLabel" />
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={12}
                        lg={12}
                        className={classes.scrollDownSm}
                      >
                        <Typography className={classes.summarizeInfo}>
                          <T id={status} />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    className={
                      isMobile ? classes.mobileBoxStyle : classes.boxStyle
                    }
                  >
                    {props.dynamicFormValues.length > 0 && (
                      <Grid container xs={12} md={5} lg={5}>
                        <Grid item xs={4} md={12} lg={12}>
                          <Typography className={classes.summarizeDescription}>
                            <T id="summarizeBankBogota.summarizePersonalInfoLabel" />
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          md={12}
                          lg={12}
                          className={classes.scrollDownSm}
                        >
                          {props.dynamicFormValues.map((info: string) => (
                            <Typography
                              className={classes.summarizeInfo}
                              key={info}
                            >
                              {info}
                            </Typography>
                          ))}
                        </Grid>
                      </Grid>
                    )}
                    <Grid container xs={12} md={5} lg={5}>
                      <Grid item xs={4} md={12} lg={12}>
                        <Typography className={classes.summarizeDescription}>
                          <T id="summarizeLabelsForSubscription.payMethodLabel" />
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={12}
                        lg={12}
                        className={classes.scrollDownSm}
                      >
                        <Typography className={classes.summarizeInfo}>
                          <T id="summarizeLabelsForSubscription.paymentSubscription" />
                        </Typography>
                      </Grid>
                      <Grid item xs={4} md={12} lg={12}>
                        <Typography className={classes.summarizeDescription}>
                          <T id="summarizeLabelsForSubscription.periodicityLabel" />
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={12}
                        lg={12}
                        className={classes.scrollDownSm}
                      >
                        <Typography className={classes.summarizeInfo}>
                          <T
                            id={`subscriptionPeriodicity.${smartlinkData.paymentConfig?.subscriptionOptions?.periodicity}`}
                          />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ResumeBankBogota;
